export const Z_INDEX_LAYERS = {
  base: 0,
  modals: 10,
  popovers: 20,
  toasts: 30,
  tooltips: 40,
};
